import React, { createContext, useCallback,Children, useMemo } from "react";
import { Button, Icon } from "semantic-ui-react";
// import { TranslateContext } from "../../NL_App/formSections/TranslateContext";
import { useEffect } from "react";

export const InvoiceToggleContext = createContext();
const reducer=(state,action)=> {
  switch (action.type) {
     case "TOGGLE_ALL":
       return {...state,...action.ids};
   
    case "TOGGLE_BY_ID":
      const { toggleId }=action
      return {...state,[`${toggleId}`]: !state[toggleId]}

    default:
      throw new Error();
  }
}
 const AccordionInvoice=({children,initialiState={},keyName='',invoiceId='', expandTitle,collapseTitle})=>{

    let toggleIds = JSON.parse(sessionStorage.getItem(keyName))
     if(keyName == 'toggleLineItems'){
      toggleIds = toggleIds?.[invoiceId]
     }


  const [state, dispatch] = React.useReducer(reducer,toggleIds!=null?toggleIds:initialiState);
  // const translate = React.useContext(TranslateContext).translate
  // const translate = (item) => item
  
  const ToggleAccordion=useCallback((value)=>{
     const state={}
     Children.toArray(children).forEach(({props})=>{
      if(!props.id && props.children){
      Children.toArray(props.children).forEach(({props})=>{
        state[props.id]=value
      })
    }
    else{
        if(props.id)
        state[props.id]=value
    }
     })
      
     dispatch({type:"TOGGLE_ALL",ids:state})
  },[children.length])

  useEffect(()=>{
    if(keyName === 'toggleInvoices'){
      sessionStorage.setItem(keyName,JSON.stringify(state))
    }else{
      const toggeleLineItemsData = JSON.parse(sessionStorage.getItem(keyName));
      sessionStorage.setItem(keyName, JSON.stringify({...toggeleLineItemsData,[invoiceId]:state}))
    }
  },[state])
 
  const isAllExpanded=useMemo(()=>{
    const values=Object.values(state)
    const ExpandedList=values.length==0 ? false : values.every(c=>c)
     return ExpandedList
  
  },[state])
  return(
    <div className="kn__accordion">
    
      <InvoiceToggleContext.Provider value={{ state, dispatch }}> 
      <div className="action-btns">
      <Button 
            basic
            color="blue"
            className="btn-toggle"
            id="expandCollapseAll"
            onClick={()=>ToggleAccordion(!isAllExpanded)}
            style={{
                  marginTop:keyName === 'toggleLineItems' ? '10px' :0,
                  marginBottom:keyName === 'toggleLineItems' ? '-12px' :0
                  }}
        >
         <Icon name={`${!isAllExpanded ? "plus" :"minus"} circle`} />
       { !isAllExpanded ? expandTitle : collapseTitle}
      </Button>
      </div>
       {children}
      </InvoiceToggleContext.Provider>
      </div>
  )
}

export default AccordionInvoice